<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form
        :model="form"
        ref="formRef"
        :rules="formRules"
        label-suffix=":"
        label-width="105px"
      >
        <el-row :gutter="24">
   
          <el-col :span="8">
            <el-form-item label="所属车场">
              <el-select
                v-model="form.spaceId"
                disabled
                style="width:100%"
                placeholder="请选择所属车场"
                @change="spaceIdChange"
              >
                <el-option
                  v-for="item in spaceIdList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="车位编号">
              <el-input
                clearable
                disabled
                v-model="form.name"
                placeholder="车位编号"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>

        
          <el-col :span="8">
            <el-form-item label="归属人姓名">
              <el-input
                clearable
                disabled
                v-model="form.personName"
                placeholder="请输入归属人姓名"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="归属人电话">
              <el-input
                clearable
                disabled
                v-model="form.personPhone"
                placeholder="请输入归属人电话"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="生效日期">
              <el-date-picker
                v-model="form.effectTime"
                style="width: 100%"
                value-format="yyyy-MM-dd 23:59:59"
                align="right"
                type="date"
                placeholder="选择租赁止期"
                disabled
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有效期止">
              <el-date-picker
                v-model="form.expiredTime"
                style="width: 100%"
                value-format="yyyy-MM-dd 23:59:59"
                align="right"
                type="date"
                placeholder="选择租赁止期"
                disabled
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="退款金额" prop="refundAmount">
                <money-input v-model="form.refundAmount"></money-input>
              
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退款后止期" prop="newEndTime">
              <el-date-picker
                v-model="form.newEndTime"
                style="width: 100%"
                value-format="yyyy-MM-dd 23:59:59"
                align="right"
                type="date"
                placeholder="选择退款后止期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="退款备注" prop="description">
              <el-input
                clearable
                v-model="form.description"
                type="textarea"
                :rows="4"
                placeholder="请输入备注"
                show-word-limit
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="    text-align: right;">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        保存
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
        取消
      </el-button>
    </div>
   
  </div>
</template>
<script>

import {
    spaceRefund,
  getParkList,

} from './index.js';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    spaceId: {},
    model: {},
  },
  data() {
    return {
      loading: false,
     
      form: {
        spaceId:"",
        name:'',
        personName:'',
        personPhone:'',
        effectTime:'',
        expiredTime:"",
        newEndTime:'',
        id:'',
        description:"",
        refundAmount:'',
      },

      formRules: {
       
        refundAmount: [{ required: true, message: '退款金额不能为空', trigger: 'blur' }],
        newEndTime: [{ required: true, message: '退款后止期不能为空', trigger: 'change' }],
     
      },
      tableHeight: '',
      spaceIdList: [],
     
     
    };
  },
  created() {
    console.log("row",this.row)
 this.form.spaceId = this.row.spaceId
 this.form.personName = this.row.personName
 this.form.personPhone = this.row.personPhone
 this.form.effectTime = this.row.effectTime
 this.form.expiredTime = this.row.expiredTime
 this.form.expiredTime = this.row.expiredTime
 this.form.newEndTime = this.row.newEndTime
 this.form.id = this.row.id
 this.form.refundAmount = this.row.refundAmount
 
 this.form.name = this.row.name
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
   
    initData() {
        getParkList().then((res) => {
        this.spaceIdList = res.data;
      });
     
    },

    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          
            spaceRefund(this.form).then((res) => {
              this.$message.success('操作成功');
              this.$emit('success');
            });
          
        } else {
        }
      });
    },


    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-16 {
  height: 54px;
}
</style>
